//import '../../node_modules/jquery/dist/jquery.js'
import $ from 'jquery'
declare global {
    interface Window {
        $: typeof $
        jQuery: typeof $
    }
}
window.$ = window.jQuery = $
import '../../node_modules/core-js/features/object/assign.js'
import '../../node_modules/core-js/features/promise/index.js'
import '../../node_modules/core-js/features/string/includes.js'
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js'
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/dropdown.js'
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/modal.js'
import '../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/tooltip.js'
import '../../node_modules/jquery-validation/dist/jquery.validate.js'
import '../../node_modules/jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive.js'
import '../../node_modules/js-cookie/src/js.cookie.js'
import './redirect'
import './typescript'